import { render } from "./VoiceChatEditorCmp.vue?vue&type=template&id=a6d1cb4a"
import script from "./VoiceChatEditorCmp.vue?vue&type=script&lang=js"
export * from "./VoiceChatEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__